import { render } from "./NoAddReturnBoxConfirmModal.vue?vue&type=template&id=5520aa04"
import script from "./NoAddReturnBoxConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoAddReturnBoxConfirmModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/NoAddReturnBoxConfirmModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5520aa04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5520aa04', __exports__)) {
    console.log('reload')
    api.reload('5520aa04', __exports__)
  }
  
  module.hot.accept("./NoAddReturnBoxConfirmModal.vue?vue&type=template&id=5520aa04", () => {
    console.log('re-render')
    api.rerender('5520aa04', render)
  })

}


export default __exports__